import React from 'react';
import { SectionWrapper } from './Shared';
export const HowItWorksSection = () => {
  const phases = [{
    num: '01',
    title: 'Fase de Eliminación',
    desc: 'Cortamos los 3 asesinos que están saboteando tus hormonas ahora mismo.'
  }, {
    num: '02',
    title: 'Fase de Activación',
    desc: 'Instalamos los hábitos de sueño y nutrición que encienden tu motor físico.'
  }, {
    num: '03',
    title: 'Fase de Optimización',
    desc: 'Consolidamos tu nuevo nivel de energía y enfoque para que dure toda la vida.'
  }];
  return <SectionWrapper className="bg-dark-800 border-y border-white/5" data-id="element-104">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-105">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight" data-id="element-106">
          Cómo <span className="text-gold-500" data-id="element-107">Funciona</span>
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-108">
        <div className="relative" data-id="element-109">
          {/* Timeline Line */}
          <div className="hidden md:block absolute left-[40px] top-0 bottom-0 w-px bg-white/10" data-id="element-110"></div>

          <div className="space-y-12" data-id="element-111">
            {phases.map((phase, idx) => <div key={idx} className="relative flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-112">
                <div className="flex items-center gap-6 md:w-auto z-10" data-id="element-113">
                  <div className="w-20 h-20 rounded-full bg-dark-900 border-2 border-gold-500 flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(212,165,116,0.2)]" data-id="element-114">
                    <span className="font-oswald text-2xl font-bold text-gold-500" data-id="element-115">
                      {phase.num}
                    </span>
                  </div>
                </div>
                <div className="bg-dark-900 border border-white/5 p-8 rounded-2xl flex-1 hover:border-gold-500/30 transition-colors w-full" data-id="element-116">
                  <h3 className="font-oswald text-2xl font-bold text-white uppercase mb-3" data-id="element-117">
                    {phase.title}
                  </h3>
                  <p className="text-zinc-400 text-lg" data-id="element-118">{phase.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
};